/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateTokenReq
 */
export interface ValidateTokenReq {
    /**
     * A JWT token. Can be either a User token (`UserTokenText`) or a Token Container (`TokenContainerText`)
     * @type {string}
     * @memberof ValidateTokenReq
     */
    token: string;
}

/**
 * Check if a given object implements the ValidateTokenReq interface.
 */
export function instanceOfValidateTokenReq(value: object): value is ValidateTokenReq {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function ValidateTokenReqFromJSON(json: any): ValidateTokenReq {
    return ValidateTokenReqFromJSONTyped(json, false);
}

export function ValidateTokenReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateTokenReq {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function ValidateTokenReqToJSON(json: any): ValidateTokenReq {
    return ValidateTokenReqToJSONTyped(json, false);
}

export function ValidateTokenReqToJSONTyped(value?: ValidateTokenReq | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
    };
}

